import {put, takeEvery, select} from 'redux-saga/effects';
import {push} from 'react-router-redux';
import get from 'get-value';
import {techDocWebsocketCommands} from '../../constants/techDocWebsocketCommands';
import {TECH_DOC_INTERNAL_TICKET_RESET} from '../../actions/techDoc/actionTechDocInternalTicket';

export function* handleTicketError(action) {
    const stateCorrelationId = get(yield select(state => state.techDocInternalTicket), `correlationId`, {default: undefined});
    const {correlationId} = action.payload;
    if (correlationId < stateCorrelationId) {
        return;
    }
    yield put(push('/documentation/internalTicket/list'));
    yield put({type: TECH_DOC_INTERNAL_TICKET_RESET});
}

function* techDocInternalTicketSaga() {
    yield takeEvery(techDocWebsocketCommands.TECH_DOC_INTERNAL_TICKET_UPDATE_ERROR, handleTicketError);
    yield takeEvery(techDocWebsocketCommands.TECH_DOC_INTERNAL_TICKET_CREATE_ERROR, handleTicketError);
    yield takeEvery(techDocWebsocketCommands.TECH_DOC_INTERNAL_TICKET_SEND_ERROR, handleTicketError);
}

export default techDocInternalTicketSaga;
